import dayjs from 'dayjs';

// This mixin provides different functions to help with dates
export default {
  methods: {
    // provides the number of days/hours that the provided date is from the current time (ex: 3d, 4h, -2d)
    fromNow(date) {
      let r = dayjs(date).diff(dayjs().startOf('day'), 'day');
      if (Math.abs(r) >= 1) return r + "d";
      r = dayjs(date).diff(dayjs(), "hour");
      if (Math.abs(r) >= 1) return r + "h";
      return "now";
    },
    // estimates the reading time in milliseconds of the text provided
    readingTime(text) {
      const wpm = 80;
      return (text.toString().trim().split(/\s+/).length / wpm) * 20000;
    },
    // converts a date to a string format that is easy to understand and read.
    // this format will be more specific for dates closer to the current date and
    // less specific for dates far away from the current date
    simpleDateFormat(date) {
      return dayjs.utc(date).calendar(null, {
        sameDay: "[Today] h:mm A",
        nextDay: "[Tomorrow] h:mm A",
        lastDay: "[Yesterday] h:mm A",
        nextWeek: "ddd h:mm A",
        lastWeek: "ddd h:mm A",
        sameElse: "M/D/YYYY"
      })
    },
    simpleDateTimeFormat(date) {
      return dayjs.utc(date).local().calendar(null, {
        sameDay: "[Today] h:mm A",
        nextDay: "[Tomorrow] h:mm A",
        lastDay: "[Yesterday] h:mm A",
        sameElse: "M/D/YYYY ddd h:mm A"
      })
    },
    formatShortMonthDate(date) {
      return dayjs(date).format("MMM D YYYY");
    },
  },
};
